module.exports = __webpack_public_path__ + "img/web elements-02.d5edb2d4.png";